var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Oval","fillOpacity":"0.611724213","fill":"#FFFFFF","cx":"61","cy":"61","r":"61","key":0}),React.createElement("circle",{"id":"Oval","fill":"#FFFFFF","cx":"61","cy":"61","r":"49.4310345","key":1}),React.createElement("path",{"d":"M76.0074535,58.580929 L56.668946,47.3516824 C55.6496264,46.7646196 54.3993016,46.7599917 53.3757304,47.3394931 C52.3521592,47.9189944 51.7056627,48.9975197 51.672931,50.180208 L51.672931,72.8084127 C51.7056627,73.991101 52.3521592,75.0696263 53.3757304,75.6491276 C54.3993016,76.228629 55.6496264,76.2240011 56.668946,75.6369383 L76.0074535,64.3228359 C76.9992351,63.7111483 77.6039655,62.623682 77.6039655,61.4518825 C77.6039655,60.2800829 76.9992351,59.1926166 76.0074535,58.580929 Z","id":"Path","fill":"#304FFE","key":2})]);
}

Play.defaultProps = {"width":"122px","height":"122px","viewBox":"0 0 122 122","version":"1.1"};

module.exports = Play;

Play.default = Play;
